export const SellZone = {
    BetterStyle: 'BT',
    OVI: 'OVI'
} as const;

export const SellZones = Object.entries(SellZone).map((item) => item[1]);

export type SellZoneType = (typeof SellZone)[keyof typeof SellZone];
